// Pure pluralization rules shared by vue-i18n config and unit tests.
// Single source of truth: src/i18n.js imports these.

export function slavicPlural(choice) {
  if (choice === 1) return 0;
  if (choice >= 2 && choice <= 4) return 1;
  return 2;
}

export function polishPlural(choice) {
  if (choice === 1) return 0;
  const lastDigit = choice % 10;
  const lastTwoDigits = choice % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) return 1;
  return 2;
}

// Mirrors vue-i18n's default English (2-form) pluralization for test parity.
export function englishPlural(choice) {
  return choice === 1 ? 0 : 1;
}

// Mirrors vue-i18n's pipe-message resolution: split on "|", trim, pick by rule.
export function resolvePlural(message, choice, rule) {
  const parts = String(message).split("|").map((s) => s.trim());
  const idx = rule(choice, parts.length);
  return parts[Math.min(idx, parts.length - 1)];
}
